import { render, staticRenderFns } from "./booking-form.vue?vue&type=template&id=5e338a90&scoped=true&"
import script from "./booking-form.ts?vue&type=script&lang=ts&"
export * from "./booking-form.ts?vue&type=script&lang=ts&"
import style0 from "./booking-form.scss?vue&type=style&index=0&id=5e338a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e338a90",
  null
  
)

export default component.exports